module.exports = __webpack_public_path__ + "img/img5.813035bd.png";